
import React, { useEffect, useState, useRef } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Button,
    Input,
    Form,
} from "reactstrap"
import { connect } from "react-redux"
import { useParams } from "react-router-dom"

//Import Action
import {
    setBreadcrumbItems,
    getAdminTicketDetail,
    updateTicketStatus,
    replyTicket
} from "../../../store/actions"

const TicketDetail = (props) => {
    const { id } = useParams()
    const [message, setMessage] = useState("")
    const [selectedFiles, setSelectedFiles] = useState([])
    const scrollRef = useRef(null)

    const API_STORAGE_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace('/api', '/storage/');

    useEffect(() => {
        props.getAdminTicketDetail(id)
    }, [id])

    const { ticketDetail } = props

    useEffect(() => {
        if (ticketDetail) {
            const breadcrumbItems = [
                { title: "CRM", link: "#" },
                { title: "Tickets", link: "/admin/tickets" },
                { title: `Ticket #${ticketDetail.id}`, link: "#" },
            ]
            props.setBreadcrumbItems(`Ticket #${ticketDetail.id}`, breadcrumbItems)
        }
    }, [ticketDetail])

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight
        }
    }, [ticketDetail?.messages])

    const handleReply = (e) => {
        e.preventDefault()
        if (message.trim() || selectedFiles.length > 0) {
            let payload;

            if (selectedFiles.length > 0) {
                payload = new FormData();
                payload.append("message", message);
                payload.append("is_internal", 0);
                for (let i = 0; i < selectedFiles.length; i++) {
                    payload.append("attachments[]", selectedFiles[i]);
                }
            } else {
                payload = {
                    message,
                    is_internal: false
                };
            }

            props.replyTicket(id, payload)
            setMessage("")
            setSelectedFiles([])
            if (document.getElementById("file-upload")) {
                document.getElementById("file-upload").value = "";
            }
        }
    }

    const handleFileChange = (e) => {
        setSelectedFiles(e.target.files)
    }

    const handleStatusChange = (status) => {
        props.updateTicketStatus(id, { status })
    }

    if (!ticketDetail) {
        return <div className="text-center p-5">Chargement...</div>
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'open': return 'badge-soft-danger'
            case 'pending': return 'badge-soft-warning'
            case 'resolved': return 'badge-soft-success'
            case 'closed': return 'badge-soft-secondary'
            default: return 'badge-soft-primary'
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col xl="4">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Détails du Ticket</CardTitle>
                            <div className="mb-3">
                                <Label className="text-muted mb-1">Crient / Entreprise</Label>
                                <h6>{ticketDetail.company?.name}</h6>
                                <p className="text-muted">{ticketDetail.user?.first_name} {ticketDetail.user?.last_name}</p>
                            </div>
                            <hr />
                            <div className="mb-3">
                                <Label className="text-muted mb-1">Sujet</Label>
                                <h6>{ticketDetail.subject}</h6>
                            </div>
                            <div className="mb-3">
                                <Label className="text-muted mb-1">Description initiale</Label>
                                <p className="text-muted">{ticketDetail.description}</p>
                            </div>
                            <hr />
                            <div className="mb-3">
                                <Label className="text-muted mb-1">Statut Actuel</Label>
                                <div>
                                    <span className={`badge ${getStatusBadge(ticketDetail.status)} font-size-12 px-3 py-2`}>
                                        {ticketDetail.status?.toUpperCase()}
                                    </span>
                                </div>
                            </div>
                            <div className="mt-4">
                                <Button color="success" size="sm" className="me-2" onClick={() => handleStatusChange('resolved')}>
                                    Marquer comme Résolu
                                </Button>
                                <Button color="secondary" size="sm" onClick={() => handleStatusChange('closed')}>
                                    Fermer
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>

                <Col xl="8">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Conversation</CardTitle>
                            <div
                                className="chat-conversation p-3"
                                style={{ height: "450px", overflowY: "auto", backgroundColor: "#f8f9fa", borderRadius: "8px" }}
                                ref={scrollRef}
                            >
                                <ul className="list-unstyled mb-0">
                                    {(ticketDetail.messages || []).map((msg, key) => {
                                        const isSystem = msg.user?.user_type === 'system';
                                        return (
                                            <li key={key} className={isSystem ? "text-end" : "text-start"}>
                                                <div className={`mb-4 d-inline-block`} style={{ maxWidth: "80%" }}>
                                                    <div className="mb-1">
                                                        <span className="fw-bold font-size-13 me-2">
                                                            {msg.user?.first_name} {msg.user?.last_name}
                                                        </span>
                                                        <small className="text-muted">
                                                            {new Date(msg.created_at).toLocaleString('fr-FR', {
                                                                day: '2-digit',
                                                                month: '2-digit',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </small>
                                                    </div>
                                                    <div className={`p-3 rounded-3 shadow-sm ${isSystem ? "bg-primary text-white" : "bg-white border"}`}
                                                        style={{
                                                            textAlign: "left",
                                                            borderRadius: isSystem ? "15px 15px 2px 15px" : "15px 15px 15px 2px"
                                                        }}>
                                                        <p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>{msg.message}</p>

                                                        {msg.attachments && Array.isArray(msg.attachments) && msg.attachments.length > 0 && (
                                                            <div className="mt-2 pt-2 border-top">
                                                                {msg.attachments.map((file, fKey) => (
                                                                    <div key={fKey} className="d-flex align-items-center mb-1">
                                                                        <i className="mdi mdi-paperclip me-2"></i>
                                                                        <a
                                                                            href={`${API_STORAGE_URL}${file.path}`}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            className={isSystem ? "text-white text-decoration-underline" : "text-primary"}
                                                                            style={{ fontSize: '12px' }}
                                                                        >
                                                                            {file.name}
                                                                        </a>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                            <div className="mt-4">
                                <Form onSubmit={handleReply}>
                                    <Row>
                                        <Col>
                                            <Input
                                                type="textarea"
                                                rows="3"
                                                placeholder="Saisissez votre réponse..."
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 align-items-center">
                                        <Col>
                                            <div className="d-flex align-items-center">
                                                <Label for="file-upload" className="btn btn-light mb-0 me-2">
                                                    <i className="mdi mdi-paperclip me-1"></i> Pièces jointes
                                                </Label>
                                                <Input
                                                    id="file-upload"
                                                    type="file"
                                                    multiple
                                                    className="d-none"
                                                    onChange={handleFileChange}
                                                />
                                                {selectedFiles.length > 0 && (
                                                    <span className="text-muted font-size-12">
                                                        {selectedFiles.length} fichier(s) sélectionné(s)
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col className="text-end">
                                            <Button color="primary" type="submit" className="w-md">
                                                Envoyer la réponse <i className="mdi mdi-send ms-1"></i>
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        ticketDetail: state.TicketsAdmin.ticketDetail,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getAdminTicketDetail,
    updateTicketStatus,
    replyTicket
})(TicketDetail)

const Label = ({ children, className, for: htmlFor }) => <label className={className} htmlFor={htmlFor}>{children}</label>
